var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isStatic
        ? [
            _c(
              "div",
              {
                staticClass: "form-control form-control--static",
                class: _vm.className,
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.item.company_name) +
                    "\n        "
                ),
              ]
            ),
          ]
        : [
            _c(
              "select",
              {
                staticClass: "form-control form-control--select",
                class: _vm.className,
                attrs: { id: _vm.id, name: _vm.name, tabindex: _vm.tabindex },
                on: { change: _vm.onChangeItem },
              },
              [
                _vm.hasPlaceholder
                  ? [
                      _c(
                        "option",
                        {
                          attrs: { value: "0" },
                          domProps: { selected: _vm.isSelectedItem(0) },
                        },
                        [_vm._v(_vm._s(_vm.placeholder))]
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.items, function (item) {
                  return _vm.$store.getters.userIsAdmin
                    ? [
                        _c(
                          "optgroup",
                          { attrs: { label: item.label } },
                          [
                            _vm._l(item.items, function (option) {
                              return [
                                _c(
                                  "option",
                                  {
                                    domProps: {
                                      value: option.id,
                                      selected: _vm.isSelectedItem(option.id),
                                    },
                                  },
                                  [_vm._v(_vm._s(option.company_name))]
                                ),
                              ]
                            }),
                          ],
                          2
                        ),
                      ]
                    : _vm._l(_vm.items, function (item) {
                        return [
                          _vm._l(item.items, function (option) {
                            return [
                              _c(
                                "option",
                                {
                                  domProps: {
                                    value: option.id,
                                    selected: _vm.isSelectedItem(option.id),
                                  },
                                },
                                [_vm._v(_vm._s(option.company_name))]
                              ),
                            ]
                          }),
                        ]
                      })
                }),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }